module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/47/assets/images/ed9780c30ea2d2847c25310a7fc64eaa.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_teach_notes.svg
// module id = DfRv
// module chunks = 0